import { definirCallbackSessaoPerdida, definirConferenciaDeIdentidade, type Plano } from './api.ts';
import { registrarSaida } from './saida.ts';
import {
  conferirIdentidadeOperadorRenovada,
  encerrarSessaoOperadorLocal,
  restaurarSessaoOperador,
} from './sessao-operador.ts';
import { conferirIdentidadeRenovada, encerrarSessaoLocal, restaurarSessao } from './sessao.ts';

/**
 * Ponto único que conhece os dois planos de acesso.
 *
 * Os módulos `sessao` e `sessao-operador` não se importam: cada um cuida do
 * seu, e é essa ignorância mútua que impede um de encerrar o outro por engano.
 * A ligação com o cliente HTTP fica aqui.
 */

definirCallbackSessaoPerdida((plano, motivo) => {
  // O motivo é registrado antes de encerrar: encerrar é o que faz o shell mandar
  // para a tela de entrada, e ela lê o motivo ao montar.
  registrarSaida(motivo);

  if (plano === 'OPERADOR') encerrarSessaoOperadorLocal();
  else encerrarSessaoLocal();
});

/**
 * A conferência de quem é o token renovado, para os dois planos.
 *
 * O cliente HTTP sabe **quando** perguntar e não sabe a quem; cada store sabe
 * responder pelo seu e não sabe do outro. Este arquivo é o único lugar do
 * sistema em que os três se encontram — a mesma razão de o callback de sessão
 * perdida morar aqui.
 */
definirConferenciaDeIdentidade((plano: Plano, identidade: unknown) =>
  plano === 'OPERADOR'
    ? conferirIdentidadeOperadorRenovada(identidade)
    : conferirIdentidadeRenovada(identidade),
);

const PREFIXO_OPERACAO = '/operacao';

/**
 * Restaura a sessão do plano correspondente ao endereço aberto.
 *
 * Só uma das duas, e não as duas: restaurar ambas custaria uma requisição a
 * mais em toda carga de página, e rotacionaria um refresh token que talvez
 * ninguém fosse usar naquela aba.
 */
export async function restaurarSessaoDoPlanoAtual(caminho: string): Promise<void> {
  if (caminho.startsWith(PREFIXO_OPERACAO)) {
    await restaurarSessaoOperador();
    return;
  }

  await restaurarSessao();
}
